import { render, staticRenderFns } from "./OrderNxKaipiao.vue?vue&type=template&id=496caf65&scoped=true"
import script from "./OrderNxKaipiao.vue?vue&type=script&lang=js"
export * from "./OrderNxKaipiao.vue?vue&type=script&lang=js"
import style0 from "./OrderNxKaipiao.vue?vue&type=style&index=0&id=496caf65&prod&scoped=true&lang=css"
import style1 from "./OrderNxKaipiao.vue?vue&type=style&index=1&id=496caf65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496caf65",
  null
  
)

export default component.exports